import Auth from "./Auth";

class LMS {
	static async get(lmsID) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms/${lmsID}`,
					{
						method: "GET",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (result.data instanceof Object === false) {
						result.data = {};
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async getAll() {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms`,
					{
						method: "GET",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (!Array.isArray(result.data)) {
						result.data = [];
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async new(name, type, adminID, url, userName, password) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const data = {
					"name": name,
					"statementsType": type,
					"idAdmin": adminID,
					"baseURL": url
				}
				if (userName) data.authUsername = userName;
				if (password) data.authPassword = password;

				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms`,
					{
						method: "POST",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						},
						body: JSON.stringify(data)
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async edit(id, name, type, adminID, url, userName, password) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const data = {
					"name": name,
					"statementsType": type,
					"idAdmin": adminID,
					"baseURL": url
				};
				if (userName !== undefined) data.authUsername = userName;
				if (password !== undefined) data.authPassword = password;

				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms/${id}`,
					{
						method: "PUT",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						},
						body: JSON.stringify(data)
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async delete(id) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${session.idAdmin}/lms/${id}`,
					{
						method: "DELETE",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}
}

export default LMS;
